export * from '@firebase/remote-config';
//# sourceMappingURL=index.esm.js.map
